import React, { Component } from "react";

import { Formik, Form } from "formik";
import { SelectInput } from "../../../../forms/components";
import Util from "../../../../libs/util";

class CreateMerchantGatewayCurrency extends Component {
	constructor(props) {
		super(props);

		this.state = {
			currency: props.currency,
		};

		this.addCurrencyModalRef = React.createRef();
	}

	componentDidUpdate(prevProps) {
		if (
			JSON.stringify(prevProps.currency) !== JSON.stringify(this.props.currency)
		) {
			this.setState({ currency: this.props.currency });
		}
	}

	getGatewayName = (gateway) => {
		if (gateway === "tctp") return "2C2P";
		if (gateway === "uqpay") return "UQPay";
		if (gateway === "stripe") return "Stripe";
		if (gateway === "ipay88") return "iPay88";
		if (gateway === "rms") return "RMS";
		if (gateway === "ghlth") return "GHLTH";
		if (gateway === "netzme") return "Netzme";
	};

	addCurrencyRate = (values, { setSubmitting, resetForm }) => {
		resetForm();
		Util.hideModal(this.props.name);
		const { code } = values;
		if (code)
			this.props.addCurrency(
				this.state.currency.find((i) => String(i.value) === String(code))
			);
	};

	render() {
		const { targetGateway } = this.props;
		const { currency } = this.state;
		return (
			<div
				id={this.props.name}
				className="uk-modal-container"
				uk-modal="stack: true"
				ref={this.addCurrencyModalRef}
			>
				<div className="uk-modal-dialog uk-modal-body">
					<h2 className="uk-modal-title">
						Add Transaction Fees for {this.getGatewayName(targetGateway)}
					</h2>
					<Formik initialValues={{ code: "" }} onSubmit={this.addCurrencyRate}>
						<Form>
							<SelectInput
								label="Currency"
								data={currency}
								id={`code`}
								name={`code`}
								initialEmpty={true}
							/>
							<p className="uk-text-right">
								<button
									className="uk-button uk-button-default uk-modal-close"
									type="button"
								>
									Cancel
								</button>
								<button className="uk-button uk-button-primary" type="submit">
									Add
								</button>
							</p>
						</Form>
					</Formik>
				</div>
			</div>
		);
	}
}

export default CreateMerchantGatewayCurrency;
